// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"2bfaa330","100":"8db45e79","279":"2bb2b799","345":"3a31c315","420":"71da303e","453":"a51a25ec","637":"52c4db16","947":"a1812db9"}[chunkId] + ".chunk.js";
};